import BaseModel from 'models/base-model';

export default class OpmServiceModel extends BaseModel({
  opmServiceStatusForBanner: '',
}) {
  setOpmServiceStatusForBanner(val) {
    return this.merge({
      opmServiceStatusForBanner: val,
    });
  }

  getOpmServiceStatusForBanner() {
    return this.opmServiceStatusForBanner;
  }

  get isServiceDown() {
    return this.opmServiceStatusForBanner === 'DOWN';
  }
}
